import type { FC } from 'react'
import { useState } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Alert, Box, Button, Checkbox, FormControlLabel, Typography } from '@mui/material'

interface PermissionsModeStepProps {
  readonly initialValue: boolean
  readonly onNext: (dangerouslySkipPermissions: boolean) => void
  readonly onBack: () => void
}

export const PermissionsModeStep: FC<PermissionsModeStepProps> = ({
  initialValue,
  onNext,
  onBack,
}) => {
  const [skipPermissions, setSkipPermissions] = useState(initialValue)

  return (
    <Box sx={containerSx}>
      <Typography variant="h6" sx={titleSx}>
        Permissions Mode
      </Typography>

      <Alert severity="warning" sx={alertSx}>
        Dangerously Skip Permissions allows Claude Code to execute all tools — including file
        writes, shell commands, and other potentially destructive operations — without asking for
        your approval. Only enable this if you fully understand the risks and trust the
        session&apos;s task.
      </Alert>

      <FormControlLabel
        control={
          <Checkbox
            checked={skipPermissions}
            onChange={(e) => setSkipPermissions(e.target.checked)}
          />
        }
        label="Enable dangerously skip permissions"
        sx={checkboxSx}
      />

      <Box sx={actionsSx}>
        <Button onClick={onBack}>Back</Button>
        <Button variant="contained" onClick={() => onNext(skipPermissions)}>
          Review
        </Button>
      </Box>
    </Box>
  )
}

const containerSx: SxProps<Theme> = {
  py: 2,
}

const titleSx: SxProps<Theme> = {
  fontWeight: 600,
  mb: 3,
}

const alertSx: SxProps<Theme> = {
  mb: 3,
}

const checkboxSx: SxProps<Theme> = {
  mb: 2,
}

const actionsSx: SxProps<Theme> = {
  display: 'flex',
  justifyContent: 'space-between',
  mt: 4,
}
